import JobSearch from "@sourceflow-uk/job-search";
import useJobs from "hooks/useJobs";
import Link from "next/link";
import React from "react";
import { Card, Col, Container, Row } from "reactstrap";
import { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./styles.module.scss";
import Arrow from "/public/site-assets/svg/black-arrow.svg";
import JobCard from '../../components/JobCard';

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/pagination";

export const LatestJobs = ({
  className,
  sectionId,
  content,
  buttons,
  swiperID = "latestJobsSwiper",
  jobSearch,
  locale,
  limit,
  filterSectors,
  filterSectorUS,
  filterRegions,
  filterJobTypes,
}) => {
  const jobs = useJobs({
    limit: limit,
    regionFilters: filterRegions,
    sectorFilters: [...(filterSectors ?? []), ...(filterSectorUS ?? [])],
    jobTypesFilters: filterJobTypes,
  });
  const settings = {
    modules: [Navigation, Pagination, Autoplay],
    loop: false,
    spaceBetween: 30,
    slidesPerView: 1,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      clickable: true,
      el: `.swiper-custom-paginations .${swiperID}`,
    },
    navigation: {
      nextEl: `.${swiperID}.swiper-next`,
      prevEl: `.${swiperID}.swiper-prev`,
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      991: {
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
      },
    },
  };
  return (
    jobs?.length >= 1 && (
      <section
        id={sectionId}
        className={`${styles.root} ${className} position-relative`}
      >
        <Container>
          <Row className="mb-4">
            <Col md={6}>
              {content && (
                <div dangerouslySetInnerHTML={{ __html: content }} />
              )}
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-md-end align-items-center"
            >
              {jobSearch ? null : (
                <div className="d-flex swiperArrowWrapper me-4">
                  <button
                    className={`${swiperID} arrow swiper-prev border-0 p-0`}
                    aria-label="Prev"
                  >
                    <Arrow />
                  </button>
                  <button
                    className={`${swiperID} arrow swiper-next border-0 ms-2 p-0`}
                    aria-label="Next"
                  >
                    <Arrow />
                  </button>
                </div>
              )}

              {buttons?.length > 0 && (
                <div className="mt-3 d-flex gap-2 flex-wrap">
                  {buttons.map(({ id, url, label, className }) => (
                    <a key={id} href={url} className={className}>
                      {label}
                    </a>
                  ))}
                </div>
              )}
              {jobSearch ? (
                <div className="w-100 mt-2 mt-md-0">
                  <JobSearch
                    options={{
                      searchResults: false,
                      searchFilters: false,
                      submitDestination: `${locale}/jobs`,
                    }}
                    translations={{
                      "input.placeHolder": "Job Title or Keyword",
                    }}
                  />
                </div>
              ) : null}
            </Col>
          </Row>
          {jobSearch ? (
            <div className="d-flex swiperArrowWrapper justify-content-end mb-4">
              <button
                className={`${swiperID} arrow swiper-prev border-0 p-0`}
                aria-label="Prev"
              >
                <Arrow />
              </button>
              <button
                className={`${swiperID} arrow swiper-next border-0 ms-2 p-0`}
                aria-label="Next"
              >
                <Arrow />
              </button>
            </div>
          ) : null}

          <Swiper {...settings}>
            {jobs?.map((job, index) => (
              <SwiperSlide key={index}>
                <JobCard
                  {...job}
                  post_lang={`${locale}/`}
                  slider={true}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="text-center swiper-custom-paginations mt-4">
            <div className={`${swiperID}`} />
          </div>
        </Container>
      </section>
    )
  );
};

export default LatestJobs;
